const ES = {
  // Generic actions
  'action:go-to-home': 'Ir al inicio',
  'action:enter': 'Entrar',
  'action:close': 'Cerrar',
  'action:login': 'Iniciar sesión',
  'action:search': 'Buscar',
  'action:logout': 'Cerrar sesión',
  'action:change': 'Cambiar',
  'action:request-shipment': 'Solicitar un envío',
  'action:use-new-address': 'Quiero usar una dirección nueva',
  'action:save-address-my-agenda': 'Guardar dirección en mi agenda',
  'action:delete-address-my-agenda-header': 'Eliminar contacto',
  'action:delete-created-address-header': 'Eliminar dirección creada',
  'action:delete-created-address-body':
    'Tienes creada una dirección de origen, ¿deseas eliminarla?',
  'action:delete-addresses-my-agenda-header': 'Eliminar contactos',
  'action:delete-address-my-agenda-body':
    '¿Estás seguro que deseas eliminar este contacto de tu agenda?',
  'action:delete-addresses-my-agenda-body':
    'Vas a eliminar {number} contactos de tu agenda. Si lo haces, no podremos recuperarlos.',
  'action:delete-address-my-agenda-body-success':
    'El contacto se ha eliminado correctamente.',
  'action:delete-address-my-agenda-body-error':
    'No hemos podido realizar la eliminación. Inténtalo de nuevo.',
  'action:delete-addresses-my-agenda-body-success':
    'Los contactos se han eliminado correctamente.',
  'action:retry': 'Reintentar',
  'action:back-to-agenda-address': 'Volver a la dirección por defecto',
  'action:back-to-home': 'Volver a la home',
  'action:go-to-previous-page': 'Volver a la página anterior',
  'action:reload-page': 'Recargar esta página',
  'action:want-choose-day-time': 'Quiero escoger otro día y hora',
  'action:want-choose-day-and-time': 'Quiero escoger día y hora',
  'action:as-soon-as-possible': 'Lo más pronto posible',
  'action:request-later': 'Lo solicitaré más tarde',
  'action:unscheduled-date': 'Sin programar',
  'action:discard': 'Descartar',
  'action:discard-changes': 'Descartar cambios',
  'action:cancel': 'Cancelar',
  'action:abandon-process': 'Salir del proceso',
  'action:delete-contacts': 'Eliminar {contacts}',
  'action:cancel-shipment':
    'Anular {count, plural, one {envío} other {envíos}}',
  'action:activate-return': 'Solicitar devolución',
  'action:return-shipping': 'Devolver envío',
  'action:upload-files': 'Elige un fichero para importar',
  'action:drag-files': 'o arrástralo aquí',
  'action:uploading-files': 'Cargando archivo...',
  'action:download': 'Descargar',
  'action:download-pod': 'Descargar POD',
  'action:import-file': 'Importar fichero',
  'action:import-contacts': 'Importar contactos',
  'action:schedule-pickup': 'Programar recogida',
  'action:download-shipping-label':
    'Descargar {count, plural, one {etiqueta} other {etiquetas}}',
  'action:print-shipping-label':
    'Imprimir {count, plural, one {etiqueta} other {etiquetas}}',
  'action:print': 'Imprimir',
  'action:go-to-next-error': 'Ir al siguiente error',
  'action:next-step': 'Siguiente pestaña',
  'action:add-destination': 'Añadir destino',
  'action:save': 'Guardar',
  'action:save-changes': 'Guardar cambios',
  'action:submit-from': 'Continuar',
  'action:submit-to': 'Continuar',
  'action:confirm': 'Confirmar',
  'action:submit-shipment': 'Continuar',
  'action:submit-customs': 'Continuar',
  'action:submit-services': 'Ver resumen de mi solicitud',
  'action:submit-summary': 'Guardar y/o imprimir etiqueta',
  'action:submit-summary-origin-pickup-point': 'Guardar',
  'action:fix-errors': 'Corregir errores',
  'action:choose-direction-from-agenda': 'Escoger una dirección de mi agenda',
  'action:new-address': 'Crea una nueva dirección',
  'action:choose-another-direction-from-list':
    'Escoger una dirección de mi agenda',
  'action:select-direction': 'Escoger esta dirección',
  'action:select-locality': 'Seleccionar localidad',
  'action:file-type': 'Tipo archivo',
  'action:download-label': 'Descargar etiqueta en PDF ahora',
  'action:change-data': 'Quiero modificar estos datos',
  'action:add-package': 'Añadir un nuevo bulto',
  'action:add-item': 'Añadir artículo',
  'action:remove-item': 'Eliminar artículo',
  'action:shipment-tracking': 'Seguimiento de envío',
  'action:execute-action': 'Ejecutar acción',
  'action:apply-filters': 'Aplicar filtros',
  'action:clean-filters': 'Limpiar filtros',
  'action:download-xlsx': 'Descargar en xlsx',
  'action:send-me-the-code': 'Enviadme el código',
  'action:save-my-new-password': 'Guardar mi nueva contraseña',
  'action:request-a-shipment': 'Solicitar un envío',
  'action:request-a-shipment-first': 'Quiero hacer mi primer envío ahora',
  'action:back': 'Volver',
  'action:see-normative': 'Ver normativa',
  'action:text-copied': 'Texto copiado',
  'action:new-shipping': 'Solicitar otro envío',
  'action:download-pdf': 'Descargar PDF',
  'action:download-app': 'Descargar App',
  'action:yes-logout': 'Sí, cerrar sesión',
  'action:back-home': 'Volver a incio',
  'action:export-excel': 'Exportar a excel',
  'action:change-delivery-point': 'Cambiar punto de recogida',
  'noun:delivery-point:error': 'Error',
  'action:understood': 'Entendido',
  'noun:actionButtons': 'Acciones',
  'noun:status': 'Estado',
  'noun:agenda': 'Mi agenda',
  'action:export-csv': 'Exportar a CSV',
  'action:remove-contact': 'Eliminar contacto',
  'action:remove-contacts': 'Eliminar {contacts} contactos',
  'action:export-contact': 'Exportar contacto',
  'action:export-contacts': 'Exportar contactos',
  'action:duplicate': 'Duplicar',

  // Punto de entrega
  'delivery-point:list:no-results':
    'Utiliza el buscador para obtener puntos de entrega.',

  // Generic nouns
  'noun:user': 'Usuario',
  'noun:password': 'Contraseña',
  'noun:my-new-password': 'Mi nueva contraseña',
  'noun:new-password': 'Nueva contraseña',
  'noun:current-password': 'Contraseña actual',
  'noun:code': 'Código',
  'noun:route': 'Dirección',
  'noun:tracking': 'Seguimiento',
  'noun:recording': 'Fichero de envíos',
  'noun:incidents': 'Incidencias',
  'noun:page': 'Página',
  'noun:incidents:lowercase': 'incidencias',
  'noun:incidents:lowercase:singular': 'incidencia',
  'noun:help-support': 'Ayuda y soporte',
  'noun:senderAddress2': 'Origen',
  'noun:recipientAddress2': 'Destino',
  'noun:refundValue': 'Reembolso',
  'noun:shippingTypeCode': 'Tipo de producto',
  'noun:shipment': 'Envío',
  'noun:shipments': 'Envíos',
  'noun:sender': 'Remitente',
  'noun:receptor': 'Destinatario',
  'noun:inventory': 'Inventario del contenido',
  'noun:normative': 'Normativa de Aduanas declarada',
  'noun:normative-1': 'Declaración de Doble Uso',
  'noun:normative-2': 'Declaración CITIES',
  'noun:normative-3': 'Exportación Permanente',
  'noun:normative-4': 'Declaración de Residuos',
  'noun:document': 'Documento {number}: {serial}',
  'noun:additional-documentation': 'Documentación adicional aduanas',
  'noun:shipments:lowercase': 'envíos',
  'noun:shipments:lowercase:singular': 'envío',
  'noun:shipment-destiny': 'Envío / Destino',
  'noun:last-status': 'Último estado',
  'noun:resume': 'Resumen',
  'noun:allocation-center': 'Centro de imputación',
  'noun:postal-address': 'Dirección postal',
  'noun:incorrect-address': 'Dirección incorrecta',
  'noun:resolve-incident': 'Resolver incidencia',
  'noun:add-address': 'Añadir dirección',
  'noun:name': 'Nombre',
  'noun:phonePrefix': 'Pref.',
  'noun:name-company': 'Nombre / Empresa',
  'noun:address': 'Dirección',
  'noun:contact-client-code': 'Código cliente habitual',
  'noun:country': 'País',
  'noun:postal-code': 'Código postal',
  'noun:problem': 'Problema',
  'noun:request': 'Petición',
  'noun:question': 'Pregunta',
  'noun:from-source': 'Por origen',
  'noun:from-destin': 'Por destino',
  'noun:complaints-and-claims': 'Reclamaciones y quejas',
  'noun:suggestions': 'Sugerencias',
  'noun:deliveryDate': 'Fecha de entrega',
  'noun:schedule': 'Horario',
  'noun:commodityType': 'Tipo de mercancía',

  'noun:city': 'Población',
  'noun:province': 'Provincia',
  'noun:mobile-phone': 'Teléfono móvil',
  'noun:mobile-phone-optional': 'Teléfono móvil (Opcional)',
  'noun:contact-phone': 'Teléfono de contacto',
  'noun:email': 'Correo electrónico',
  'noun:contact-email': 'Email de contacto',
  'noun:floor': 'Piso',
  'noun:stair': 'Escalera',
  'noun:letter': 'Letra',
  'noun:pick-up-date': 'Fecha de recogida',
  'noun:timetable': 'Horario',
  'noun:time-slot': 'Franja horaria',
  'noun:comments': 'Observaciones',
  'noun:additional-services': 'Servicios adicionales',
  'noun:customs': 'Aduanas',
  'noun:additional-services-title':
    '¿Hay algún servicio adicional que quieras añadir?',
  'noun:additional-services-description':
    'Ponemos a tu disposición los siguientes servicios adicionales, selecciona aquellos que necesites:',
  'noun:pudos-additional-services-title':
    'Lo sentimos, no es posible añadir ningún servicio adicional en el modo de entrega en un Punto CTT Express',
  'noun:additional-services-empty':
    'No has contratado ningún servicio adicional',
  'noun:weight': 'Peso',
  'noun:length': 'Largo',
  'noun:width': 'Ancho',
  'noun:height': 'Alto',
  'noun:yes': 'Sí',
  'noun:no': 'No',
  'noun:type-of': 'Tipo de {type}',
  'noun:service-type': 'Tipo de servicio',
  'noun:clientReference': 'Referencia',
  'noun:number-of-packages': 'Nº de bultos',
  'noun:total-weight-kgs': 'Peso total en kgs',
  'noun:last-update': 'Última actualización',
  'noun:declared-value': 'Valor declarado',
  'noun:refund': 'Reembolso',
  'noun:refund-amount': 'Importe del reembolso',
  'noun:refund-description':
    'Este servicio te permite la gestión del cobro del valor de la mercancía en destino. Inserta la cantidad que el destinatario tiene que abonar en el momento de recibir su paquete (hasta un máximo de {formattedAmount} €).  Servicio exclusivo para envíos con destino España o Portugal.',
  'noun:insurance-merchandise': 'Valor mercancía asegurada',
  'noun:additional-coverage': 'Cobertura Adicional',
  'noun:additional-coverage-description-national':
    'Cobertura por pérdida o daño del valor del contenido declarado (hasta un máximo de {formattedAmount} €). Introduce el valor declarado de tu mercancía. El coste de esta cobertura será del 1,50% del valor declarado (mínimo 2 €).',
  'noun:additional-coverage-description-international':
    'Cobertura por pérdida o daño del valor del contenido declarado (hasta un máximo de {formattedAmount} €). Introduce el valor declarado de tu mercancía. El coste de esta cobertura sera del 1% del valor declarado (mínimo 10€).',
  'noun:insurance-merchandise-description':
    'Introduce el valor aproximado en por el que está asegurada tu mercancía.',
  'noun:additional-return':
    'Este servicio te permite la entrega de tu mercancía al destinatario, a la vez que te da la posibilidad de que el destinatario nos entregue en ese mismo momento otra mercancía para ser retornada. ',
  'noun:additional-slip-scan':
    'Servicio de digitalización del albarán del cliente, firmado por el destinatario en la entrega.',
  'noun:insurance-value': 'Valor del seguro',
  'noun:origin-data': 'Datos de origen',
  'noun:destination-data': 'Datos de destino',
  'noun:name-surname': 'Nombre y apellidos',
  'noun:phone': 'Teléfono',
  'noun:description': 'Descripción',
  'noun:date': 'Fecha',
  'noun:selected-timetable': 'Horario preferido',
  'noun:ask-about': 'Preguntamos por',
  'noun:shipment-detail': 'Detalle del envío',
  'noun:commercial-bill': 'Datos factura comercial',
  'noun:contracted-service': 'Servicio contratado',
  'noun:reference': 'Referencia',
  'noun:total-packages': 'Bultos',
  'noun:CP-sender': 'CP Remitente',
  'noun:CP-destination': 'CP Destinatario',
  'noun:CTT-point': 'Punto CTT Express',
  'noun:scaned-albaran': 'Escaneo de Albarán',
  'noun:albaran-pt': 'AlbaránPT',
  'noun:return': 'Retorno',
  'noun:declared-price': 'Valor declarado',
  'noun:dni-verification': 'Verificación DNI',
  'noun:reference2': 'Referencia2',
  'noun:enter-size-and-aprox-weight': 'Introduce las medidas y peso aproximado',
  'noun:appraisal-weight': 'Peso de tasación',
  'noun:reported weight': 'Peso informado',
  'noun:insured-value': 'Valor asegurado',
  'noun:id-verification': 'Verificación DNI',
  'noun:department': 'Departamento',
  'noun:file_name': 'Nombre del fichero',
  'noun:upload_date': 'Fecha de carga',
  'noun:upload_hour': 'Hora',
  'noun:success_lines': 'Envíos correctos',
  'noun:error_lines': 'Envíos incorrectos',
  'noun:shippingCode': 'Nº de envío',
  'noun:shippingDate': 'Fecha',
  'noun:shippingStatusCode': 'Estado',
  'noun:incidentDescription': 'Descripción de incidencia',
  'noun:clientCenterCode': 'Centro de cliente',

  'noun:reports': 'Reportes',
  'noun:report': 'Destinatario',
  'noun:download': 'Documento',
  'noun:subscription': 'Suscripción',
  'noun:type': 'Tipo',
  'noun:settings': 'Ajustes',

  'noun:recipientName': 'Destinatario',
  'noun:filters': 'Filtros',
  'noun:reportConfig': 'Configuración de informes',
  'noun:reportList': 'Lista de informes',
  'noun:state-filters': 'Filtrar por estado',
  'noun:incident-filters': 'Filtrar por incidencias gestionables',
  'noun:read': 'Leída',
  'noun:all': 'Todos',
  'noun:from': 'Desde',
  'noun:to': 'Hasta',
  'noun:by-incident-type': 'Por tipo de incidencia',
  'noun:by-last-status': 'Por último estado',
  'noun:search-by-date': 'Buscar por fecha',
  'noun:any-date': 'Cualquier fecha',
  'noun:last-month': 'Último mes',
  'noun:last-quarter': 'Último trimestre',
  'noun:want-search-by-range': 'Quiero buscar por rango',
  'noun:date-first-reading': 'Fecha de grabación',
  'noun:expected-delivery-date': 'Fecha prevista de entrega',
  'noun:tomorrow': 'Mañana',
  'noun:not-defined': 'No definida',
  'noun:edit': 'Editar',
  'noun:cancel': 'Anular',
  'noun:my-contracts': 'Mis contratos',
  'noun:billing': 'Facturación',
  'noun:invoices': 'facturas',
  'noun:print-settings': 'Ajustes de impresión',
  'noun:user-zone': 'Zona de usuario',
  'noun:account': 'Mi cuenta',
  'noun:go-to-print-settings': 'Ir a ajustes de impresión',
  'noun:invoice-number': 'Nº de factura',
  'noun:client-center-code': 'Código cliente centro',
  'noun:amount-in-€': 'Importe en €',
  'noun:amount': 'Importe',
  'noun:base-amount': 'Importe base',
  'noun:weight-extra-amount': 'Adeudo exceso peso/medidas',
  'noun:city-origin': 'Localidad de origen',
  'noun:city-destiny': 'Localidad de destino',
  'noun:last-status-date': 'Fecha último estado',
  'noun:article:country': ' el país',
  'noun:article:name': ' el nombre del establecimiento',
  'noun:article:postalCode': ' el código postal',
  'noun:article:city': ' la ciudad',
  'noun:article:route': ' la calle',
  'noun:article:streetNumber': ' el número de la calle',
  'noun:and': ' y ',
  'noun:elements-per-page': 'Elementos por página',
  'noun:shipments-per-page': 'Envíos por página',
  'noun:contacts-per-page': 'Contactos por página',
  'noun:contacts': 'Contactos',
  'noun:date-and-time': 'Fecha y hora',
  'noun:shipping-item': 'Bulto',
  'noun:-appraisal-weight': 'Peso total aproximado',
  'noun:sure-logout': '¿Seguro que deseas cerrar la sesión?',
  'noun:all-your-shippings': 'Todos tus envíos',
  'noun:my-agenda': 'Agenda',
  'noun:imported-register': 'Registro de importación',

  'noun:under-construction': '¡En construcción!',
  'noun:under-construction-explanation':
    'Estamos trabajando para que pronto puedas ver y descargar tus facturas aquí.',
  'noun:shipping-number': 'Número de envío',
  'noun:contact-data': 'Datos de contacto',
  'noun:subject': 'Asunto',
  'noun:CLIENTWEB_CI_1': 'Configuración impresora',
  'noun:CLIENTWEB_CI_2': 'Módulos integración (Prestashop, Odoo, Shopify...)',
  'noun:CLIENTWEB_CI_3': 'Ayuda con mi web de clientes',
  'noun:CLIENTWEB_ATC_1': 'Incidencias de envíos',
  'noun:CLIENTWEB_ATC_2': 'Sugerencias',
  'noun:CLIENTWEB_SALES_1': 'Dudas sobre medidas, pesos, tarifas…',
  'noun:CLIENTWEB_SALES_2': 'Solicitud de material (bolsas, etiquetas…)',
  'noun:CLIENTWEB_BILL_1': 'Facturas y abonos',
  'noun:CLIENTWEB_BILL_2': 'Envíos contrarrembolso',
  'noun:other': 'Otros',
  'noun:manifest': 'Manifiesto',
  'noun:generate-manifest': 'Generar manifiesto',
  'noun:generation-manifest-date': 'Fecha de generación de manifiesto:',
  'noun:generation-manifest-packages': 'N.º TOTAL BULTOS:',
  'noun:generation-manifest-shippings': 'N.º TOTAL ENVÍOS:',
  'noun:generation-manifest-weight': 'PESO TOTAL INFORMADO:',
  'noun:generation-manifest-return': 'TOTAL REEMBOLSOS:',
  'noun:recipient-date': 'Datos del destinatario',
  'noun:returns': 'Devoluciones',
  'noun:activate-return': 'Solicitar devolución',
  'noun:return-number': 'Nº de envío de la devolución:',
  'noun:unscheduled-pickups': 'Recogidas sin programar',
  'noun:maintenance': 'Mantenimiento',
  'noun:sorry-for-inconveniences': 'Disculpe las molestias',

  // Fields
  'field:optional': '{field} <span> | Opcional</span>',
  'field:money-suffix': ' €',
  'field:first-pickup-option':
    '{minDate, date, full} de {minDate, time, short} a {maxDate, time, short}',

  // Generic messages
  'message:saving': 'Guardando...',
  'message:loading': 'Cargando...',
  'message:asap': 'Recogida propuesta',
  'message:fixedPickup': 'Mi recogida fija',
  'message:choose-pickup-with-fixed-pickup':
    'Esta recogida será adicional a tu recogida fija.',
  'message:time-slot': `Si quieres que recojamos tu envío en la fecha y franja horaria que has seleccionado envía tu solicitud durante {minutes, plural,
      =0 {el próximo minuto}
      one {el próximo minuto}
      other {los próximos # minutos}
    }.`,
  'message:no-results': 'No hay resultados',
  'message:no-results:shippings':
    'No hay envíos con la búsqueda que has realizado',
  'message:no-results:returns':
    'No hay devoluciones con la búsqueda que has realizado',
  'message:no-results:incidents':
    'No hay incidencias con la búsqueda que has realizado',
  'message:no-results:unscheduled':
    'No hay envíos sin programar con la búsqueda que has realizado',
  'message:form-errors:title': 'Hay errores en el formulario',
  'message:form-errors:detail':
    'Para pasar a otra sección, deber corregirlos primero o descartar los cambios que has hecho.',
  'message:save-changes:title': '¿No quieres guardar los cambios?',
  'message:save-changes:detail':
    'Si quieres continuar y no perderlos, debes guardarlos ahora',
  'message:abandon-process:title': 'Vas a salir del proceso de solicitud',
  'message:abandon-process:detail':
    'Si sales ahora, se perderán todos tus datos y deberás empezar un nuevo proceso.',
  'message:successful-shipment':
    '<p>¡Enhorabuena!</p>Tu envío ha sido grabado correctamente',
  'message:outside-origin':
    'Recuerda que si este origen no está dentro de tu zona habitual, esto podría cambiar las condiciones del servicio.',
  'message:outside-destination-km-10h':
    'Determinadas poblaciones conllevan suplemento por kilometraje en el servicio 10:00h.',
  'message:outside-destination-km-10h-mi':
    'Ver poblaciones con Suplemento Kilometraje',
  'message:choose-day': 'Primero, escoge un día para la recogida.',
  'message:choose-timeslot': 'Finalmente, selecciona una franja horaria.',
  'message:choose-schedule': 'A continuación, selecciona un horario.',
  'message:you-are-going-to-cancel-shipment': 'Vas a anular estos envíos',
  'message:if-you-cancel-this-shipment-you-cant-recovery':
    'Una vez que anules estas solicitudes no podrás recuperarlas.',
  'message:most-sustainable-option': 'Opción más sostenible',
  'message:search-by-street-zone-or-postal-code':
    'Busca el código postal o la dirección aquí y selecciona un Punto CTT Express',
  'message:click-on-confirm-to-continue':
    'Haz clic en “Confirmar” para poder continuar con el proceso.',
  'message:pickup-point-contact-data':
    'Una vez depositemos la mercancía en el Punto CTT Express, avisaremos a tu destinatario para que proceda a recogerla.',
  'message:unscheduled-date-subtitle':
    'Recuerda que puedes programar esta recogida desde el detalle de envío y en la sección de seguimiento.',

  'pickupPoint:title': 'Recogida directa en Punto CTT Express',
  'pickupPoint:subtitle': 'El origen será seleccionado por el remitente',

  // Weekdays
  'weekday:1': 'Lunes',
  'weekday:2': 'Martes',
  'weekday:3': 'Miércoles',
  'weekday:4': 'Jueves',
  'weekday:5': 'Viernes',
  'weekday:6': 'Sábado',
  'weekday:7': 'Domingo',

  // Generic errors
  'error:404:title': 'No hemos encontrado la página que buscas',
  'error:404:text':
    'Te recomendamos que vuelvas a la portada o utilices las opciones del menú para seguir viendo contenidos mientras solucionamos el problema.',
  'error:server:title': 'Parece que tenemos un problema',
  'error:server:text':
    'Te recomendamos que vuelvas a la portada o utilices las opciones del menú para seguir viendo contenidos mientras solucionamos el problema.',
  'error:connection:title': 'Parece que hay un problema de conexión',
  'error:connection:text':
    'Es posible que no tengas conexión a Internet o que ésta esté fallando. Te recomendamos que:',
  'error:internal:title': 'Parece que tenemos un problema',
  'error:internal:text':
    'No podemos mostrarte la página que buscas, es posible que haya algún problema de conexión con el servidor.',
  'error:contact-with-us':
    'Si el problema persiste, <Link>contacta con nosotros</Link>.',
  'error:network':
    'Parece que hay un problema de conexión. Revisa tu conexión a internet o inténtalo de nuevo más tarde.',
  'error:limit-exceeded':
    'Ha excedido el número máximo de intentos. Por favor, inténtelo de nuevo más tarde.',
  'error:code-mismatch': 'Código inválido. Por favor, inténtalo de nuevo.',
  'error:general':
    'Se ha producido un error durante la solicitud. Por favor, inténtalo de nuevo más tarde.',
  'error:cancel-shipment':
    'Se ha producido un error durante la anulación de los envíos. Por favor, inténtalo de nuevo.',

  // Form errors
  'error:form:request-generic': 'Hubo un error al realizar la petición',
  'error:form:debug': 'Error forzado para propósitos de prueba',
  'error:form:step':
    'Hubo un error en este paso. Por favor, modifica los datos para continuar',
  'error:form:search-not-possible':
    'No ha sido posible realizar la búsqueda, por favor inténtalo de nuevo.',
  'error:form:search-not-possible-verify-postal-code':
    'No hemos podido identificar el Código Postal para esta dirección, por favor, intente ser más preciso con la dirección',

  // Form field errors
  'error:field:required': 'El campo es obligatorio.',
  'error:field:conditions-required':
    'Por favor, acepta los campos marcados en rojo:',
  'error:field:postal-code:required': 'El código postal es obligatorio.',
  'error:field:streetNumber:required': 'El número de la calle es obligatorio.',
  'error:field:route:required': 'La calle es obligatoria.',
  'error:field:min-length-required': 'La longitud mínima es de 6 caracteres.',
  'error:field:min-string-length': 'La longitud mínima es de {min} caracteres.',
  'error:field:max-string-length': 'La longitud máxima es de {max} caracteres.',
  'error:field:min-array-length': 'Debe introducir al menos un elemento.',
  'error:field:min-date': 'La fecha mínima es el {min, date, ::yyyyMMdd}.',
  'error:field:min-number': 'El valor mínimo es {min, number}.',
  'error:field:max-number': 'El valor máximo es {max, number}.',
  'error:field:min-monetary-amount': 'El valor mínimo es {formattedAmount} €.',
  'error:field:max-monetary-amount': 'El valor máximo es {formattedAmount} €.',
  'error:field:email': 'Debe introducir una dirección de email válida.',
  'error:field:password': 'Debe introducir una contraseña válida.',
  'error:field:invalid': 'El valor no es correcto.',
  'error:field:cp-format':
    'El código postal es incorrecto para el país seleccionado',
  'error:field:package-row:empty-fields':
    'Completa todos los campos obligatorios.',
  'error:field:address-autocomplete':
    'Por favor, añade {missingFields} para continuar.',
  'error:field:not-found-results-with-postal-code':
    'No hemos encontrado resultados con este código postal, por favor revisa que esté correcto.',
  'error:shipment-number:length': 'El número de envío debe tener 22 digitos.',
  'error:shipment-number:not-found': 'El numero de envío no existe.',
  'error:origin-address:invalid-origin':
    'No es posible grabar una recogida en una dirección de fuera de España o Portugal, escoge otra dirección para poder continuar.',
  'error:field:package-row:weight-exceeded':
    'El peso por bulto introducido supera el máximo permitido de {maxWeight}kg.',
  'error:field:package-row:measure-exceeded':
    'El alto, ancho o largo supera la medida más larga permitida de {maxMeasure} cm.',
  'error:field:package-row:measures-sum-exceeded-pudos':
    'La suma del alto, ancho y largo no puede ser mayor de {maxPerimeter} cm.',
  'error:field:package-row:measures-sum-exceeded':
    'Este origen o destino no admite el peso volumétrico informado',
  'error:field:package-row:weight-minimum':
    'El peso mínimo por bulto debe ser superior a 0 kg.',
  'error:field:package-row:width-minimum':
    'El largo mínimo por bulto debe ser superior a 0 cm.',
  'error:field:package-row:length-minimum':
    'El ancho mínimo por bulto debe ser superior a 0 cm.',
  'error:field:package-row:height-minimum':
    'El alto mínimo por bulto debe ser superior a 0 cm.',
  'error:field:max-files': 'El número máximo de archivos es {maxFiles}.',
  'error:customs:min-value': 'La cantidad mínima es de 1.',
  'error:customs:max-value': 'La cantidad máxima es de 9999999.',
  'error:customs-description:max-value':
    'La longitud no puede superar los 70 carácteres',

  // Frontpage
  'frontpage:placeholder': 'Página raíz placeholder',
  'frontpage:user':
    'Loggeado como el usuario {user} a fecha de {date, date, full} a las {date, time, full}',

  // Login
  'login:title': 'Iniciar sesión en CTT Express',
  'login:title-mobile': 'Entra en tu zona personal',
  'login:error:form:user-not-found':
    'El correo y/o la contraseña no son correctos.',
  'login:error:form:user-requires-new-password':
    'No se pudo iniciar sesión con una contraseña temporal. Contacte con el administrador para cambiar su contraseña.',
  'login:remember-password': 'No recuerdo mi contraseña',
  'login:recover-password': 'Recuperar mi contraseña',
  'login:create-account-explanation':
    'Si tienes un negocio y todavía no tienes cuenta en CTT Express déjanos tus datos <strong><link>aquí</link></strong> y te llamamos. ¡Sin compromiso!',

  // Send Code
  'request-password-reset:explanation':
    'Inserta tu email de registro en CTT Express para enviarte un código de acceso:',
  'request-password-reset:warning:check-spam':
    'Si no ves nuestro correo en tus mensajes, revisa tu bandeja de spam',

  // Reset Password
  'reset-password:enter-code-and-choose-password':
    'Introduce aquí el código que te hemos enviado y elige una contraseña:',
  'reset-password:email-not-received-send-again':
    'No he recibido el correo, mandádmelo otra vez',
  'reset-password:warning:validate-password':
    'Tu contraseña debe tener al menos 8 caracteres, incluyendo al menos una mayúscula y un número.',

  // Shipping Send Form
  'shipping-send-form:title': 'Quiero solicitar un envío',
  'shipping-send-form:new-address:phone-length-error': 'Teléfono incorrecto',
  'shipping-send-form:address:no-phone-error':
    'La dirección seleccionada no está completa. Es necesario que añadas el número de teléfono para poder continuar.. ',
  'shipping-send-form:address:no-phone-error-center':
    'La dirección seleccionada no está completa. Es necesario que añadas el número de teléfono para poder continuar, contacta con tu comercial.',
  'shipping-send-form:new-address:phone-min-length-error':
    'Teléfono incorrecto. Debe tener 6 carácteres como minimo',
  'shipping-send-form:new-address:phone-max-length-error':
    'Teléfono incorrecto. Debe tener 15 carácteres como maximo',
  'shipping-send-form:new-address:phone-format-error': 'Formato incorrecto',
  'shipping-send-form:new-address:phone-format-or-length-error':
    'Formato o longitud del teléfono incorrecta',
  'shipping-send-form:new-address:dni-format-error': 'Formato incorrecto',
  'shipping-send-form:new-address:phone-digits-error':
    'El número debe tener 9 digitos',
  'shipping-send-form:new-address:phone-initial-number-error':
    'Un número de movil no puede comenzar por 9',
  'shipping-send-form:new-address:placeholder':
    'Busca tu código postal aquí y los campos de abajo se autorrellenarán',
  'shipping-send-form:new-address-agenda:placeholder':
    'Busca tu dirección y los campos se autorrellenarán',
  'shipping-send-form:origin': 'Recoger en origen:',
  'shipping-send-form:summary:pickup':
    '{weekDay}, {minDate, date, short} de {minDate, time, short} a {maxDate, time, short} hrs.',
  'shipping-send-form:pickup-date':
    'Pasaremos a recogerlo el {minDate, date, ::ddMMyyyy} de {minDate, time, short} a {maxDate, time, short} hrs.',
  'shipping-send-form:fixed-pickup-date':
    'Pasaremos a recogerlo el {fromDate, date, ::ddMMyyyy} de {fromDate, time, short} a {toDate, time, short} hrs.',
  'shipping-send-form:origin:timetable:morning':
    'Mañana ({minDate, time, short} a {maxDate, time, short} hrs.)',
  'shipping-send-form:origin:timetable:afternoon':
    'Tarde ({minDate, time, short} a {maxDate, time, short} hrs.)',
  'shipping-send-form:origin:new-address:address-finder':
    'Buscador de direcciones',
  'shipping-send-form:origin:new-address:address': 'Dirección',
  'shipping-send-form:origin:new-address:postal-code': 'Código postal',
  'shipping-send-form:origin:new-address:postal-code-placeholder': '1234...',
  'shipping-send-form:origin:new-address:postal-code-es-placeholder': '12345',
  'shipping-send-form:origin:new-address:postal-code-pt-placeholder': '1234567',
  'shipping-send-form:origin:new-address:province': 'Provincia',
  'shipping-send-form:origin:new-address:city': 'Ciudad',
  'shipping-send-form:origin:new-address:locality': 'Localidad',
  'shipping-send-form:origin:new-address:comments-label':
    'Ejemplo: Carretera Puxeiros, km 6, Nave 1',
  'shipping-send-form:origin:pickup:choose-schedule': 'Elige el horario',
  'shipping-send-form:origin:pickup:asap-requirements':
    'Para calcular la fecha de recogida más rápida, primero necesitamos que nos facilites una dirección postal',
  'shipping-send-form:origin:pickup:choose-requirements':
    'Antes de ofrecerte las fechas disponibles, necesitamos que nos facilites una dirección postal',
  'shipping-send-form:origin:timetable:anytime': 'A cualquier hora del día',
  'shipping-send-form:origin:timetable:select-timeslot':
    'Elegir franja horaria',
  'shipping-send-form:origin-mobile': 'Entregar en origen:',
  'shipping-send-form:destination-mobile': 'Entregar en destino:',
  'shipping-send-form:title:center': '¿Quién hace el envío?',
  'shipping-send-form:title:origin-address': '¿Dónde quieres que lo recojamos?',
  'shipping-send-form:label:existing-address': 'En una de mis direcciones',
  'shipping-send-form:label:contract-address': 'Dirección de contrato',
  'shipping-send-form:label:other-address': 'En otra dirección',
  'shipping-send-form:label:new-address': 'En una dirección nueva',
  'shipping-send-form:label:pick-up-point': 'En un Punto CTT Express',
  'shipping-send-form:label:tooltip-autofill-postal-code':
    'Este campo se autorrellena al ingresar el código postal.',
  'shipping-send-form:helper-text:several-localities-associate-with-postal-code':
    'Hemos encontrado varias localidades asociadas al código postal introducido, por favor selecciona la localidad que corresponda.',
  'shipping-send-form:helper-text:not-found-localities-input-manually':
    'No hemos encontrado localidades asociadas al código postal introducido, por favor rellena el campo manualmente.',
  'shipping-send-form:helper-text:not-found-province-input-manually':
    'No hemos encontrado provincias asociadas al código postal introducido, por favor rellena el campo manualmente.',
  'shipping-send-form:contact-details': '¿Por quién preguntamos?',
  'shipping-send-form:title:pick-up-date':
    '¿Cuándo quieres que pasemos a recogerlo?',
  'shipping-send-form:title:additional-comments':
    '¿Hay algo que necesite saber nuestro conductor?',
  'shipping-send-form:placeholder:additional-comments':
    'Carretera, Urbanización, Bloque, etc.',
  'shipping-send-form:label:additional-comments':
    'Otros datos relevantes de la dirección',
  'shipping-send-form:action:back-from': 'Volver a origen',
  'shipping-send-form:action:back-to': 'Volver a destino',
  'shipping-send-form:action:back-shipment': 'Volver a envío',
  'shipping-send-form:action:back-services': 'Volver a servicios adicionales',
  'shipping-send-form:action:back-customs': 'Volver a aduanas',
  'shipping-send-form:action:back-summary': 'Volver al resumen',
  'shipping-send-form:action:confirm-address': 'Confirmar dirección',
  'shipping-send-form:action:confirm-data-destination':
    'Confirmar datos de destino',
  'shipping-send-form:action:cancel-my-request': 'Cancelar mi solicitud',
  'shipping-send-form:action:process-shipment': 'Tramitar este envío',
  'shipping-send-form:action:confirm-cancellation': 'Si, quiero cancelar',
  'shipping-send-form:snackbar-address-saved':
    'Dirección guardada en tu agenda',
  'shipping-send-form:alert-address-saved':
    'Esta dirección ha sido guardada en tu agenda.',
  'shipping-send-form:alert-address-saved-error':
    'No ha sido posible guardar la dirección en tu agenda.',
  'shipping-send-form:try-again': 'Intentar de nuevo',
  'shipping-send-form:time-slot-option':
    'de {minDate, time, short} a {maxDate, time, short}',
  'shipping-send-form:error:time-slot':
    'La opción seleccionada ya no está disponible',
  'shipping-send-form:origin:postal-code:invalid-format':
    'Formato postal incorrecto',
  'shipping-send-form:origin:no-available-hours': 'No hay fechas disponibles',
  'shipping-send-form:origin:select-postal-code':
    'Primero, dinos un código postal',
  'shipping-send-form:origin:pickup-not-available':
    'Hemos tenido un problema obteniendo la fecha de recogida más rápida',
  'shipping-send-form:origin:not-available-dates':
    'En estos momentos no es posible ofrecerte fecha de recogida. Inténtalo más tarde y si el error persiste contacta con el equipo de Soporte informático.',
  'shipping-send-form:origin:select-poblation':
    'No aparecen fechas disponibles porque no nos has facilitado un código postal',
  'shipping-send-form:title:destination-address':
    'Danos la dirección de destino',
  'shipping-send-form:agenda': 'Agenda',
  'shipping-send-form:address-edition': 'Editar dirección de agenda',
  'shipping-send-form:address-edition:success':
    'La dirección ha sido modificada correctamente',
  'shipping-send-form:address:no-address':
    'Aún no tienes ninguna dirección de destino en tu agenda. Inserta una nueva dirección para continuar.',
  'shipping-send-form:address-edition:return':
    'Volver al buscador de direcciones',
  'shipping-send-form:shipment:service-type': 'Escoge un tipo de servicio',
  'shipping-send-form:shipment:custom': 'Aranceles aduaneros',
  'shipping-send-form:shipment:custom-charge':
    'Selecciona quién se hará cargo de los Aranceles Aduaneros:',
  'shipping-send-form:shipment:service-type:info':
    'Sólo te mostramos los que mejor se adaptan a tu solicitud',
  'shipping-send-form:shipment:reference-number':
    '¿Quieres añadir tu propio nº de referencia?',
  'shipping-send-form:shipment:commodity-type': 'Tipo de mercancía',
  'shipping-send-form:shipment:select-commodity-type':
    'Seleccione el tipo de mercancía:',
  'shipping-send-form:shipment:packages': 'Introduce las medidas y peso',
  'shipping-send-form:shipment:packages:content':
    'Cuanto más preciso seas con el peso del envío, mejor servicio podremos ofrecerte.',
  'shipping-send-form:shipment:information': 'Información acerca de tu envío',
  'shipping-send-form:shipment:need-information':
    'Cuanto más preciso seas con el peso del envío, mejor servicio podremos ofrecerte:',
  'shipping-send-form:shipment:fill-packages':
    'Rellena la información de los bultos de tu envío para poder ver los servicios que mejor se adapten.',
  'shipping-send-form:shipment:wrong-sizes-or-weight':
    'No existen servicios para las medidas y peso introducido.',
  'shipping-send-form:shipment:purchase-sale': 'Es una compra/venta',
  'shipping-send-form:shipment:between-individuals':
    'Es un envío ordinario entre particulares',
  'shipping-send-form:shipment:documents': 'Documentos',
  'shipping-send-form:shipment:merchandise': 'Mercancía',
  'shipping-send-form:shipment:content-type':
    '¿Qué tipo de contenido quieres enviar?',
  'shipping-send-form:shipment:address-change-detected':
    'Cambio de dirección postal detectado',
  'shipping-send-form:shipment:origin-address-changed':
    'Has cambiado el origen de tu envío. Debes rellenar de nuevos los bultos y seleccionar una nueva tarifa.',
  'shipping-send-form:shipment:destin-address-changed':
    'Has cambiado el destino de tu envío. Debes rellenar de nuevo los bultos y seleccionar una nueva tarifa.',
  'shipping-send-form:shipment:merchandise-info':
    'Cuanto más preciso seas con el peso y medidas del envío, mejor previsión de tasación de envíos podremos ofrecerte.',
  'shipping-send-form:shipment:merchandise-label': 'Tipo de mercancía',
  'shipping-send-form:shipment:merchandise-placeholder':
    'Electrónica, baterías, ropa, alcohol...',
  'shipping-send-form:shipment:limitations':
    'Algunos tipos de envío tienen limitaciones. Antes de que nos des estos datos, necesitamos saber qué tipo de servicio vas a necesitar.',
  'shipping-send-form:shipment:own-reference-number':
    'Si añades tu propio número de referencia, te resultará más fácil hacer el seguimiento',
  'shipping-send:success:title': 'Hemos transmitido tu solicitud',
  'shipping-send:success:description':
    'No te preocupes, no tienes que apuntar nada. Ya tienes una copia en tu correo',
  'shipping-send:cancel:title': 'Vas a interrumpir el proceso',
  'shipping-send:cancel:description':
    'Si cancelas tu solicitud, perderas todos los datos que hayas Introducido',
  'shipping-send-form:shipment:destination-address-label':
    'Dirección de destino',
  'shipping-send-form:keep-in-mind': 'Ten en cuenta que...',
  'shipping-send-form:sending-documents':
    'Nos has indicado que tu envío contiene documentos, <strong>por lo tanto no necesitas ningúna documentación adicional para aduanas.</strong>',
  'shipping-send-form:shipping-restrictions':
    'Recuerda que, dependiendo del destino de tu envío, algunos tipos de mercancías podrían estar sujetas a restricciones o condiciones especiales.',
  'shipping-send-form:customs-documentation-text':
    'El destino que has seleccionado requiere de documentación aduanera. A continuación, ponemos a tu disposición un {invoiceModel}, una {inventorySheet} y las {instructions} sobre como cumplimentarlas para facilitarte el proceso (si dispones de un modelo de documentación puedes utilizar el tuyo). Recuerda adjuntar dicha documentación cumplimentada al exterior de tu paquete. ',
  'shipping-send-form:invoice-model': 'modelo de documentación aduanera',
  'shipping-send-form:instructions': 'instrucciones',
  'shipping-send-form:inventory-sheet': 'hoja extra de inventario',
  'shipping-send-form:download-fill-form':
    'No olvides descargar y rellenar el siguiente formulario para aduanas.',
  'shipping-send-form:download-form': 'Descargar formulario',
  'shipping-send-form:accurate-best-service':
    'Cuanto más preciso seas, mejor servicio podremos ofrecerte.',
  'shipping-send-message:schedule-may-change':
    'Los horarios pueden estar sujetos a variaciones a causa de fuerza mayor.',
  'shipping-send-message:request-pickup-later':
    'Recuerda que <strong>puedes programar esta recogida desde el detalle de envío y en la sección de seguimiento.</strong> Nosotros quedaremos a la espera de tus indicaciones para que nuestros repartidores pasen a recoger este envío.',
  'shipping-send-form:customs:info':
    'El destino/origen que has escogido conlleva aduanas por lo que es importante que completes los siguientes datos para la creación de la documentación necesaria. Ten en cuenta que esta documentación se la enviaremos directamente a los organismos aduaneros:',
  'shipping-send-form:customs:no-necessary': 'Documentación',
  'shipping-send-form:customs:no-necessary-body':
    'El envió que va a realizar no precisa de documentación.',
  'shipping-send-form:customs:title': 'Documentación necesaria para tu envío',
  'shipping-send-form:customs:sender-info': '1. Información del remitente',
  'shipping-send-form:customs:receptor-info': '2. Información del destinatario',
  'shipping-send-form:customs:inventory-custom': '3. Inventario del contenido',
  'shipping-send-form:customs:additional': '4. Documentación adicional',
  'shipping-send-form:customs:authorized':
    'Sí he leído y declaro que la información proporcionada es correcta y que la mercancía que envío cumple la ',
  'shipping-send-form:customs:custom-normative': 'Normativa de Aduanas.',
  'shipping-send-form:customs:custom-normative-text-1':
    'Los envios realizados por CTT Express son transportados en total cumplimiento con la ley y las regulaciones internacionales, por lo que es necesario que aceptes la información de los reglamentos internacionales en las siguientes materias para poder realizar tu envío tal como exigen las autoridades aduaneras.',
  'shipping-send-form:customs:custom-normative-text-declaration':
    'DECLARACIÓN DE DOBLE USO:',
  'shipping-send-form:customs:custom-normative-text-declaration-body':
    'Ciertos productos/tecnología (incluido software) pueden destinarse tanto a usos militares como nucleares, por lo que las autoridades aduaneras requieren de una declaración en la que reflejes que el contenido que estás enviando NO tiene/tendrá uso militar.',
  'shipping-send-form:customs:custom-normative-text-cities':
    'DECLARACIÓN CITIES:',
  'shipping-send-form:customs:custom-normative-text-cities-body':
    'Las autoridades aduaneras solicitan que añadas al envío tu declaración de que la mercancía que estás enviando NO procede de especies protegidas recogidas dentro del acuerdo CITIES para la protección de especies de fauna y flora en peligro de extinción.',
  'shipping-send-form:customs:custom-normative-text-waste':
    'DECLARACIÓN DE RESIDUOS:',
  'shipping-send-form:customs:custom-normative-text-waste-body':
    'Las autoridades aduaneras solicitan que añadas al envío tu declaración de que la mercancía que estás enviando NO son residuos (basura o similar).',
  'shipping-send-form:customs:custom-normative-text-exportacion':
    'EXPORTACIÓN PERMANENTE:',
  'shipping-send-form:customs:custom-normative-text-exportacion-body':
    'CTT Express solo realiza exportaciones definitivas / permanentes, lo cual consiste en que las mercancías salen de territorio aduanero destinadas a permanecer definitivamente fuera.',
  'shipping-send-form:customs:readed':
    'Sí, autorizo la firma digital de mi declaración de aduanas.',
  'shipping-send-form:customs:upload-files':
    'Existen ciertas mercancías que están restringidas por normas específicas; aquí puedes adjuntar documentación adicional que desees presentar a los organismos aduaneros para facilitar el tránsito del envío. (por ejemplo: Declaración para embarque de batería de litio, etc...)',
  'shipping-send-form:customs:inventory-custom-number': 'Artículo {number}',
  'shipping-send-form:customs:form:type': 'Tipo',
  'shipping-send-form:customs:form:individual': 'Particular',
  'shipping-send-form:customs:form:dni': 'DNI o pasaporte',
  'shipping-send-form:customs:form:reason': 'Motivo del envío',
  'shipping-send-form:customs:form:company': 'Empresa',
  'shipping-send-form:customs:form:company-name': 'Nombre de la empresa',
  'shipping-send-form:customs:form:bill': 'Nº factura',
  'shipping-send-form:customs:form:prosecutor':
    'Nº identificación fiscal europea (NIF-IVA)',
  'shipping-send-form:customs:form:prosecutor-es':
    'Nº identificación fiscal (NIF-CIF)',
  'shipping-send-form:customs:form:category': 'Categoría',
  'shipping-send-form:customs:form:taric_code': 'Código taric',
  'shipping-send-form:customs:form:taric_code_alert':
    'En esta sección es necesario que insertes el código arancelario (nº Taric/Tariff) que es un código internacional para clasificar las mercancías utilizado por las autoridades aduaneras. Encuentra tu número Taric insertando el contenido en inglés en la sección "advanced search" de ',
  'shipping-send-form:customs:form:taric_code_alert_link': 'ec.europa.eu.',
  'shipping-send-form:customs:form:place': 'Lugar de fabricación',
  'shipping-send-form:customs:form:description':
    'Descripción del contenido (obligatoriamente en inglés y mayúsculas)',
  'shipping-send-form:customs:form:description-es':
    'Descripción del contenido (obligatoriamente en mayúsculas)',
  'shipping-send-form:customs:form:description-summary': 'Descripción',
  'shipping-send-form:customs:form:quantity': 'Número de artículos',
  'shipping-send-form:customs:form:price': 'Valor del artículo',
  'shipping-send-form:customs:form:select:personal_effects':
    'Objetos personales',
  'shipping-send-form:customs:form:select:sold': 'Compra/venta',
  'shipping-send-form:customs:form:select:repair_and_return': 'Devolución',
  'shipping-send-form:customs:form:select:sample': 'Muestra',
  'shipping-send-form:customs:form:select:certificate_of_origin':
    'Certificado de origen',
  'shipping-send-form:customs:form:select:other': 'Otro',
  'shipping-send-form:customs:article-number-format-error':
    'No se permiten decimales',
  'shipping-send-form:customs:taric-code-eigth':
    'Debe tener una longitud de 8 carácteres o más',
  'shipping-send-form:customs:taric-code-empty': 'Este campo es obligatorio',
  'shipping-send-message:weight-1':
    'Peso máximo por bulto 40kg / Medida máxima por bulto 240 cm (sumando largo + ancho + alto) o con ninguna medida superior a 150 cm.',
  'shipping-send-message:weight-2':
    'Peso máximo 20kg. Medida máxima por bulto 240 cm (sumando largo + ancho + alto) o con ninguna medida superior a 150 cm.',
  'shipping-send-message:weight-3':
    'Peso máximo 5kg. Medida máxima por bulto 240 cm (sumando largo + ancho + alto) o con ninguna medida superior a 150 cm.',
  'shipping-send-message:weight-4':
    'Peso máximo por bulto 30 kg / Medidas máximas por bulto 40 cm x 30 cm x 30 cm.',
  'shipping-send-message:weight-5':
    'Peso máximo por bulto 10 kg / Medidas máximas por bulto 50 cm x 50 cm x 50 cm.',
  'shipping-send-form:origin-pudo:info-1':
    'La mercancía puede entregarse en cualquiera de nuestros Puntos CTT Express de la España peninsular o Baleares. Consulta nuestros ',
  'shipping-send-form:origin-pudo:available-points-link':
    'puntos disponibles aquí',
  'shipping-send-form:origin-pudo:info-2':
    'Debe cumplir las siguientes características:',
  'shipping-send-form:origin-pudo:max-weight': 'Máximo 20 kg',
  'shipping-send-form:origin-pudo:mono-package': 'Envíos monobulto',
  'shipping-send-form:origin-pudo:max-dimensions': 'Máx. 160cm (60x40x60)',
  'shipping-send-form:origin-pudo:email-instruction-1': 'Introduce la ',
  'shipping-send-form:origin-pudo:email-instruction-bold':
    'dirección de correo electrónico',
  'shipping-send-form:origin-pudo:email-instruction-2':
    ' a la que enviaremos el código necesario para mostrar en el Punto CTT Express y que pueda admitir tu envío.',
  'shipping-send-form:one-package-alert': 'Las recogidas a través de Punto Ctt Express deben tener un único bulto.',
  // Send summary'
  'shipping-send-summary:legal':
    '<p>Asegúrate de que todos los datos de tu envío son correctos. CTT Express se reserva el derecho de no proceder a la recogida/entrega del paquete si las medidas y/o peso de tu envío presentan gran diferencia respecto a las adjuntas en tu envío.</p> <p>Recuerda también que los horarios pueden estar sujetos a variaciones a causa de fuerza mayor.</p>',

  // Send success
  'shipping-send-success:shipping-code': 'Código de envío:',
  'shipping-send-success:shipping-number': 'Número de envío:',
  'shipping-send-success:helper-text':
    '<p>Tu envío se ha grabado correctamente.</p> Recuerda que en la sección <strong>Seguimiento de esta web</strong> puedes ver todos tus envíos grabados y sus estados, así como imprimir sus etiquetas. <p>A continuación, también, puedes imprimir o descargar la etiqueta ahora.</p>',
  'shipping-send-success:helper-text-origin-pudo':
    '<p>Tu envío se ha grabado correctamente.</p> Recuerda que en la sección <strong>Seguimiento de esta web</strong> puedes ver todos tus envíos grabados y sus estados.',
  'shipping-send-success:helper-text-mobile':
    'Si quieres consultarlo en otro momento, te hemos enviado un correo con el detalle del envío.',

  // Cancel shipping
  'shipping-send-cancel:alert-description':
    'Recuerda que sólo se pueden anular aquellos envíos cuyo estado sea “Grabado”.',

  // Cancel manifest
  'generate-manifest-cancel:alert-description':
    'Por favor, selecciona algún envio que aún no haya sido recogido para generar el manifiesto',

  // Addresses
  'address:without-name': '{address}, {postalCode}, {city}, {country}',
  'address:contract-default': 'Asociada al contrato',
  'address:address-book': 'Asociada a tu agenda',

  // Helpers
  'helper:origin': 'Desde dónde lo mandas',
  'helper:destination': 'A quién se lo envías',
  'helper:shipment': 'Dinos cómo es la mercancía',
  'helper:customs': 'Documentación para aduanas',
  'helper:additional-services': 'Cómo va a ser la entrega',
  'helper:resume': 'Comprueba tu solicitud',
  'helper:max-amount': 'Máximo {formattedAmount} €',

  // Placeholders
  'placeholder:client': 'Escribe o selecciona de la lista',
  'placeholder:postal-code': '00000 | -',
  'placeholder:max-characters': 'Máximo {number} caracteres...',
  'placeholder:date': 'dd/mm/aaaa',
  'placeholder:kilograms': '{number} kg', // TODO: rename
  'placeholder:centimetres': '{number} cm', // TODO: rename
  'placeholder:service-type': 'Escoge un servicio',
  'placeholder:phone': '+34 000 000 000',
  'placeholder:search-by-name-or-address': 'Busca por nombre o dirección',
  'placeholder:search-by-name-or-address-or-code':
    'Busca por nombre, dirección o código cliente habitual',
  'placeholder:search-by-name-or-address-or-company':
    'Busca por nombre o dirección',
  'placeholder:select-country': 'Selecciona un país',

  // Tooltips
  'tooltip:locality':
    'Modifica el nombre de la localidad si consideras que el código postal introducido también corresponde a otro municipio.',
  'tooltip:go-tracking': 'Ir al seguimiento de envíos',
  'tooltip:delete-file': 'Eliminar fichero de la lista',
  'tooltip:success-files': 'Total envíos grabados correctamente',
  'tooltip:errored-files': 'Total envíos NO grabados',
  'tooltip:download-CSV':
    'Fichero con los envíos que han dado error en la carga',
  'tooltip:processing-request': 'Procesando solicitud',
  'tooltip:return-shipment': 'Ver envío de devolución',
  'tooltip:schedule': 'Programar la recogida de esta mercancía',
  'tooltip:not-resoluble':
    'Esta incidencia NO la puedes resolver a través de esta web',
  'tooltip:resoluble':
    'Esta incidencia la puedes resolver a través de esta web',
  'tooltip:solved':
    'A esta incidencia ya se ha dado una solución y está pendiente de ejecutarse',
  'tooltip:regular-addresses':
    'Este es el listado de tus direcciones habituales.',
  'tooltip:return-email':
    'El remitente recibirá una notificación al email permitiéndole escoger la fecha y/o la dirección de recogida e incluso escoger un Punto CTT Express para entregarnos la mercancía.',
  'tooltip:service-price':
    'Tarifa de acuerdo a los pesos y medidas informados.',
  'tooltip:measures-price':
    'Completa peso y medidas para conocer la tarifa de tu envío',
  'tooltip:weigth-price': 'Completa peso para conocer la tarifa de tu envío',
  'tooltip:new-direction':
    'Utiliza esta opción si quieres hacer un envío a una dirección que no esté en tu listado.',
  'tooltip:countries-origin':
    'Los puntos de origen de un envío son España, Andorra y Portugal',
  'tooltip:service-type':
    'Te mostramos los servicios que puedes contratar teniendo en cuenta tus datos de origen y destino',
  'tooltip:reference-number':
    'Si añades tu número de referencia habitual, podrás buscar y encontrar con facilidad tu envío en el listado de seguimientos.',
  'tooltip:purchase-sale':
    'Entendemos como compra/venta aquel envío de mercancía en el que el destinatario ha efectuado un pago por recibir la mercancía. Esto no afecta a la compra/venta de artículos de segunda mano entre particulares.',
  'tooltip:custom:nif':
    'Ten en cuenta que, si el remitente y/o destinatario es una empresa, deberás incluir sus números NIF-IVA . Consulta con la Agencia Tributaria cómo solicitarlo.',
  'tooltip:custom:reason':
    'Indica el motivo por el que realizas el envío. Trata con total transparencia el motivo de tu envío. Si no, podrías incurrir en retrasos innecesarios.  Recuerda que CTT Express solo realiza exportaciones definitivas/permanentes, es decir, las mercancías salen de territorio aduanero destinadas a permanecer definitivamente fuera.',
  'tooltip:custom:description':
    'Recuerda incluir la descripción en inglés y en mayúsculas la descripción de cada artículo que hayas incluido en tu envío (si necesitas ayuda con el inglés puedes usar el traductor de Google). La descripción debe explicar qué es, con qué material está fabricado y para qué se utiliza (si procede). Por ejemplo, si envías zapatillas de mujer de piel azules y nuevas puedes insertar:  “WOMEN´S TENNIS SHOES / BLUE / BOVINE LEATHER / NEW”',
  'tooltip:custom:description-es':
    'La descripción debe explicar qué es, con qué material está fabricado y para qué se utiliza (si procede). Por ejemplo, si envías zapatillas de mujer de piel azules y nuevas puedes insertar:  “ZAPATILLAS DE DEPORTE DE MUJER / AZULES / DE CUERO / NUEVAS”',
  'tooltip:custom:quantity':
    'Al inserta el número de artículos, si es exactamente el mismo producto solo es necesario que lo insertes una vez (por ejemplo, si mandas 2 camisetas de algodón idénticas, solo es necesario que lo añadas una vez insertando un 2 en el campo de N.º de artículos.).',
  'tooltip:custom:price':
    'Todos los productos deben tener un valor, aunque el artículo sea una devolución, una muestra o un regalo, sigue teniendo por lo menos el valor de los costes de producción (no puedes poner como valor 0€ a un objeto que envíes). Inserta el valor real de cada artículo para evitar que Aduanas te pida información adicional y esto ocasione retrasos. Si el artículo que envías lo has fabricado tú, puedes poner el valor total de la suma de los costes de los materiales y el valor de producción.',
  'tooltip:custom:place':
    'Incluye el país de fabricación del producto, sí no has fabricado tu mismo el producto podrás encontrar la información sobre el país de fabricación de tu artículo en la documentación del fabricante  o en la etiqueta con un “Hecho en…” / ”Made in”',
  'tooltip:custom:category':
    'Si en el desplegable no se encuentra exactamente tu artículo elige la opción “Otros artículos” y rellena el nuevo campo Código Taric manualmente.',
  'tooltip:custom:category-es':
    'Si en el desplegable no se encuentra exactamente tu artículo elige la opción “Otros artículos”.',
  // Alerts
  // Alerts
  'alert:document':
    'Entendemos por documento cualquier envío en formato papel de menos de 10Kg de peso. Todo lo demás será considerado como mercancía',
  'alert:merchandise':
    'Recuerda que, dependiendo del destino de tu envío, <strong>algunos tipos de mercancías podrían estar sujetas a restricciones o condiciones especiales</strong>. En el caso de que no sea posible, por restricciones legales, el envío de tu mercancía, contactaremos contigo a la mayor brevedad posible.',
  'alert:no-products':
    'No existen productos disponibles para el origen y destino seleccionado. Consulte con su persona de contacto',
  'alert:environment-error':
    'Estamos configurando tu Web, por favor inténtalo más tarde',
  'alert:go-to-download-page': 'Ir a la página de descarga',
  'alert:shippings-search:no-shippings':
    'No tienes ninguna solicitud con esa referencia. Revísalo o inténtalo con otro número.',

  // Service types
  'service-type:24h': '24 horas',
  'service-type:weekend': 'Fin de semana',

  // Other services
  'service:with-return': 'Envío con retorno',
  'service:with-handling': 'Con manipulación',
  'service:scan-client-slip': 'Escaneo albarán cliente',
  'service:verify-code': 'Comprobación QR, Bidi...',
  'service:rdp-send': 'Recogida directa en Punto CTT Express',

  // Download filenames
  'shipping-send:label:filename': 'ctt-etiqueta-{id}.pdf',

  'shipping:extension-error':
    'Este archivo no tiene un formato valido. Recuerda que los formatos aceptados son  .DOC, .DOCX, .XLS, .XLSX, .TXT, .RTF, .JPG, .GIF, .BMP, .TIF, .PNG o .PDF',
  'shipping:size-error':
    'Este archivo es demasiado grande. Por favor, intenta reducir su peso o selecciona un archivo más pequeño. Recuerda que puedes subir archivos de hasta 5 Mb.',
  'shipping:upload-error':
    'Se ha producido un error durante el proceso de importación. Por favor, refresca la página, importa tu archivo nuevamente o inténtalo más tarde.',
  'shipping:name-error':
    'Este archivo supera la longitud máxima permitida de 244 carácteres para el nombre del fichero.',

  //Agenda
  'agenda:title': 'Agenda',
  'agenda:description': 'Desde aquí puedes gestionar tus contactos.',
  'agenda:import-contacts': 'Importar contactos',
  'agenda:add-contact': 'Añadir contacto',
  'agenda:edit-contact': 'Editar contacto',
  'agenda:select-center': 'Ver agenda de:',
  'agenda:empty-state': 'Aún no tienes contactos en esta agenda',
  'agenda:add-success': 'El contacto se ha añadido correctamente.',
  'agenda:add-error':
    'No hemos podido añadir el contacto, inténtalo de nuevo más tarde.',
  'agenda:edit-success': 'El contacto se ha actualizado correctamente.',
  'agenda:edit-error':
    'No hemos podido editar el contacto, inténtalo de nuevo más tarde.',
  'agenda:delete-file-success': 'El fichero se ha eliminado correctamente.',
  'agenda:delete-file-error':
    'No hemos podido eliminar este fichero, inténtalo de nuevo más tarde.',
  'agenda:delete-file': '¿Quieres eliminar este fichero?',
  'agenda:delete-file-body1':
    'Al darle confirmar, estarás borrando únicamente el fichero del registro de importación. Los contactos importados se mantendrán guardados en la agenda.',
  'agenda:delete-file-body2':
    'Si lo que deseas es eliminar un contacto, debes hacerlo desde la pestaña {myAgenda}',
  'agenda:import-description':
    'Añade contactos a tu agenda forma masiva importando un fichero en tres simples pasos.',
  'agenda:how-import': '¿Cómo importar?',
  'agenda:step-1-1': 'Para comenzar, descarga el {csv} de ejemplo',
  'agenda:step-1-2': 'fichero CSV',
  'agenda:step-2': 'Completa la información de tus contactos',
  'agenda:step-3': 'Importa o arrastra tu archivo',
  'agenda:info': 'Para más información, descarga nuestro tutorial.',
  'agenda:succesfull-title':
    '¡La solicitud de carga se ha recibido exitosamente!',
  'agenda:succesfull-body':
    'Estamos procesando el contenido de tu fichero. Puedes revisar el estado de este proceso en la {nextPage}',
  'agenda:succesfull-next-page': 'siguiente página',

  //Shipping Recording
  'shipping-recording:title': 'Importación de fichero de envíos',
  'shipping-recording:description':
    'Solicita tus envíos nacionales (Excepto Canarias, Ceuta y Melilla) y a Portugal de forma masiva importando un fichero. Por favor, sube <strong>un fichero por cada centro</strong> para registrar correctamente los envíos.',
  'shipping-recording:massive-request': 'Genera una nueva solicitud masiva',
  'shipping-recording:import-your-file': 'Importa tu archivo ',
  'shipping-recording:save-time':
    'y ahorra tiempo en el proceso de solicitud de tus envíos.',
  'shipping-recording:how-import': '¿Cómo importar?',
  'shipping-recording:step-1-1': 'Descarga el {csv} de ejemplo',
  'shipping-recording:step-1-2': 'fichero XLSX',
  'shipping-recording:step-2': 'Completa la información de tus envíos',
  'shipping-recording:step-3': 'Importa o arrastra tu archivo',
  'shipping-recording:info': 'Para más información, descarga  {tutorial}.',
  'shipping-recording:tutorial': 'nuestro tutorial.',
  'shipping-recording:delete-file-success':
    'El fichero se ha eliminado correctamente.',
  'shipping-recording:delete-file-error':
    'No hemos podido eliminar este fichero, inténtalo de nuevo más tarde.',
  'shipping-recording:delete-file': '¿Quieres eliminar este fichero?',
  'shipping-recording:delete-file-body1':
    'Recuerda que únicamente vas a eliminar el fichero de esta lista, lo cual no afecta a los envíos.',
  'shipping-recording:delete-file-body2':
    'Tus envíos solicitados correctamente no se verán afectados, si lo que deseas es anular algún envío que has cargado con este fichero dirígete a la sección de {shippingTracking}',
  'shipping-recording:succesfull-title':
    '¡La solicitud de carga se ha recibido exitosamente!',
  'shipping-recording:succesfull-body':
    'Estamos procesando el contenido de tu fichero. Puedes revisar el estado de este proceso en la {nextPage}',
  'shipping-recording:succesfull-next-page': 'siguiente página',
  'shipping-recording:succesfull-alert':
    '<p> Recogeremos tu mercancia en la primera fecha disponible. </p> <p> Recuerda que si dispones de Recogida fija establecida recogeremos tu mercancía en el horario y dirección habitual. </p> ',
  'shipping-recording:asap-warning':
    'Por cada envío se calculará la fecha y hora más pronto posible, teniendo en cuenta el código postal y el horario de grabación.',
  'shipping-recording:asap-warning-2':
    'Ten en cuenta que el tiempo mínimo en el que el repartidor puede pasar a buscar la mercancía es a partir de 1 hora desde que se ha procesado la solicitud.',
  'shipping-recording:asap-info':
    'Para saber la fecha de recogida exacta de cada envío, deberás dirigirte a la sección de Seguimiento de envíos una vez procesada tu solicitud.',
  'shipping-recording:later-warning':
    'Recuerda que puedes programar esta recogida desde el detalle de envío y en la sección de seguimiento. Nosotros quedaremos a la espera de tus indicaciones para que nuestros repartidores pasen a recoger este envío.',
  'shipping-recording:later-info':
    'Para saber la fecha de recogida exacta de cada envío, deberás dirigirte a la sección de Seguimiento de envíos una vez procesada tu solicitud.',
  'shipping-recording:choose-info':
    'Para saber la fecha de recogida exacta de cada envío, deberás dirigirte a la sección de Seguimiento de envíos una vez procesada tu solicitud.',
  'shipping-recording:extension-error':
    'Este archivo no tiene un formato valido. Recuerda que los formatos aceptados son .csv, xls o xlsx.',
  'shipping-recording:size-error':
    'Este archivo es demasiado grande. Por favor, intenta reducir su peso o selecciona un archivo más pequeño. Recuerda que puedes subir archivos de hasta X Mb.',
  'shipping-recording:upload-error':
    'Se ha producido un error durante el proceso de importación. Por favor, refresca la página, importa tu archivo nuevamente o inténtalo más tarde.',

  //Reports
  'reports:title': 'Reportes',
  'reports:description':
    'Lista de todos los informes disponibles, a los cuales el usuario se podrá suscribir.',
  'reports:confirm-sub-title': 'Confirma la activación a la suscripción',
  'reports:confirm-sub-description':
    'Tendrás acceso a este informe a través de la FTP. Recuerda que puedes ajustar tus preferencias de frecuencia en {settings}.',
  'reports:config-report': 'Configuración de frecuencia',
  'reports:frequency': 'Frecuencia',
  'reports:day': 'Día',
  'reports:days': 'Días',
  'reports:week': 'Semana',
  'reports:daily': 'Diario',
  'reports:weekly': 'Semanal',
  'reports:month': 'Mensual',
  'reports:hour': 'Hora',

  // Shipping Tracking
  'shipping-tracking:title': 'Seguimiento de envíos',
  'shipping-tracking:description':
    'En este listado puedes hacer un seguimiento sobre el estado de todos tus envíos.',
  'shipping-tracking:find-shipments': 'Encuentra los envíos que estás buscando',
  'shipping-tracking:by-shipment': 'Por envío',
  'shipping-tracking:search-in-the-incidents': 'Buscar en las incidencias',
  'shipping-tracking:show-incidents': 'Mostrar sólo los envíos con incidencias',
  'shipping-tracking:current-status': 'Este es el estado actual de tu envío',
  'shipping-tracking:tracking': 'Seguimiento',
  'shipping-tracking:shipment-step-by-step': 'Tu envío paso a paso',
  'shipping-tracking:see-complete-tracking': 'Ver seguimiento completo',
  'shipping-tracking:pickup:success:title':
    'Tu envío llegará en la fecha prevista',
  'shipping-tracking:returned:title':
    'Tu envío ha sido devuelto al punto de origen y llegará el ',
  'shipping-tracking:pickup:not-defined': 'No definida',
  'shipping-tracking:pickup:no-delivery-date:subtitle':
    'Te podremos dar la fecha estimada de entrega en cuanto recojamos tu pedido.',
  'shipping-tracking:pickup:error:subtitle':
    'Lo sentimos, es posible que tu envío tarde más de lo esperado',
  'shipping-tracking:send:success:title': 'El envío se ha entregado con éxito',
  'shipping-tracking:send:no-delivery-date:title':
    'Aún no existe una fecha de recogida programada.',
  'shipping-tracking-chip:service-type': 'Tipo de servicio',
  'shipping-tracking-chip:postal-code': 'Código postal',
  'shipping-tracking-chip:origin-postal-code': 'Código postal origen',
  'shipping-tracking-chip:destin-postal-code': 'Código postal destino',
  'shipping-tracking-chip:center-code': 'Código centro cliente',
  'shipping-tracking-chip:country': 'País',
  'shipping-tracking-chip:shipping-code-or-reference':
    'Número de envío o referencia',
  'shipping-tracking:cancelled:title': 'Tu envío fue anulado el:',
  'shipping-tracking:cancelled:subtitle':
    '{datetime, date, ::ddMMyyyy} {datetime, date, ::kkmmss}',
  'shipping-tracking:check-pickup-address':
    'Comprueba la dirección de recogida de tu mercancía.',
  'shipping-tracking:if-insert-address-is-not-correct-create-new-shipping':
    'Si la dirección insertada no es correcta es necesario que crees un nuevo envío.',
  'shipping-tracking:if-address-is-correct-contact-customer-support':
    'Si la dirección es correcta contacta con atención al cliente para poder resolver esta incidencia.',
  'shipping-tracking:already-resolved':
    'Ya se ha realizado una acción sobre está incidencia y tu envío sigue su viaje, en breve se mostrará el nuevo estado.',

  // Tracking
  'tracking:incorrect_address': 'Dirección incompleta/incorrecta',
  'tracking:no_answer': 'Destinatario no contesta',
  'tracking:no_answer_r': 'Remitente no contesta',
  'tracking:refuses': 'Rehusado',
  'tracking:no_effective': 'Sin efectivo en la entrega',
  'tracking:pending': 'Pendiente de entrada en la red',
  'tracking:recorded': 'Grabado',
  'tracking:collected': 'Recogido',
  'tracking:merchandise-origin': 'Mercancía en delegación de origen',
  'tracking:merchandise-destination': 'Mercancía en delegación de destino',
  'tracking:in-transit': 'En tránsito',
  'tracking:available': 'Disponible para recoger',
  'tracking:distribution': 'En reparto',
  'tracking:manifested': 'Manifestados',
  'tracking:pudo': 'Depositado en Punto CTT',
  'tracking:delivered': 'Entregado',
  'tracking:returned': 'Devuelto',
  'tracking:delivered-plural': 'Entregados',
  'tracking:cancelled': 'Anulado',
  'tracking-line:shipping-cancelled': 'Envío anulado',
  'tracking-line:shipping-unscheduled': 'Sin programar',
  'tracking-line:pickup-unscheduled': 'Recogida sin programar',
  'date-digest:title:expected-delivery-date': 'Fecha prevista de entrega',
  'date-digest:title:delivered-date': 'Fecha de entrega',
  'date-digest:title:cancellation-date': 'Fecha de la anulación del envío',
  'date-digest:body:not-defined-date': 'No definida.',
  'date-digest:body:unscheduled-date':
    'Aún no existe una fecha de recogida programada. Te podremos dar la fecha estimada de entrega en cuanto recojamos tu pedido.',
  'date-digest:body:delivery-date': `{isTomorrow, select,
      true {Mañana, }
      other {}
    }{weekDay} <strong>{date, date, ::ddMMyyyy}</strong>`,
  'date-digest:body:cancellation-date':
    '<strong>{datetime, date, ::ddMMyyyy}</strong> {datetime, date, ::kkmmss}',
  'date-digest:footer:not-recoverable-warning':
    'Los envíos anulados no pueden ser recuperados',

  // Detail
  'shipping-detail:title': 'Detalle de envío',
  'shipping-detail:shipment-number': 'Nº de envío:',
  'shipping-detail:return-number': 'Nº de envío devuelto:',
  'shipping-detail:original-number': 'Nº de envío original:',
  'shipping-detail:pt': 'Nº de envío portugués:',
  'shipping-detail:see-return': 'Ver devolución',
  'shipping-detail:ctt-express-point': 'Punto CTT Express',

  // Home
  'home:title': 'Inicio',
  'home:welcome': `{name, select,
      unnamed {Bienvenido}
      other {Bienvenido, {name}}
    }`,
  'home:your-activity': 'Esta es tu actividad en el último mes.',
  'home:shipment-status': 'Situación de envíos',
  'home:shipment-locator': 'Localizador de envíos',
  'home:shipment-locator-subtitle':
    'Información actualizada de todos tus envíos.',
  'home:find-shipment': 'Encuentra el envío que buscas',
  'home:result-shipment': 'Resultado de la búsqueda',
  'home:shipment-search-results': 'Este es el resultado de tu búsqueda',
  'home:shipment-locator-input-helper':
    'Recuerda que puedes introducir el número de envío o referencia completo o una fracción de este.',
  'home:shipment-locator-input-helper-mobile':
    'Debes introducir el nº completo',
  'home:shipment-locator-input-placeholder': 'Nº de envío o nº de referencia',
  'home:shipment-recording-input-placeholder': 'Nombre del archivo',
  'home:filters': 'Filtrar {type} por',
  'home:filters:delete': 'Borrar todos los filtros',
  'home:latest-incidents': 'Últimas incidencias',
  'home:latest-shipments': 'Últimos envíos',
  'home:no-results':
    'No tienes ninguna solicitud con ese número. Revísalo o inténtalo con otro número.',
  'home:view-complete-list': 'Ver lista de envíos completa',
  'home:total-shipments': 'Total envíos',

  // Billing
  'billing:title': 'Facturación',
  'billing:subtitle':
    'Aquí puedes consultar tu tarifa contratada. Si tienes alguna duda sobre la tarifa, productos y/o servicios, tu consultor comercial te ayudará.',
  'billing:filter-client-center': 'Por código de cliente centro',
  'billing:see-my-rate-2023': 'Ver mi tarifa 2023',
  'billing:see-my-rate-2024': 'Ver mi tarifa 2024',
  'billing:find-review-documentation-contract':
    'Aquí podrás encontrar y revisar la documentación de tu contrato en cualquier momento.',
  'billing:select-invoice': 'Seleccionar tarifa',
  'billing:see-invoices': 'Aquí puedes consultar tus tarifas',

  //Reports
  'reports:empty-reports': 'Aún no tienes habilitado ningún informe.',
  'reports:empty-reports-description':
    'Recuerda que para ver los informes debes suscribirte a aquellos informes que más te interesen.',
  'reports:empty-reports-tooltip':
    'Las suscripciones son una funcionalidad más de tu Área de Clientes que nos permite entregarte grandes volúmenes de datos de forma automática y periódica.',
  'reports:config': 'Configurar informes',

  // Empty states
  'empty:no-shipment-request': 'No tienes solicitudes de envío',
  'empty:no-incident-shipments': 'No tienes ninguna incidencia en tus envíos',
  'empty:want-first-shipment': 'Quiero hacer mi primer envío ahora',
  'empty:no-shippings-title': 'No hay envíos para mostrar',
  'empty:no-results': 'No hay resultados para mostrar',
  'empty:no-results-search': 'No se han encontrado resultados para tu búsqueda',
  'empty:no-shippings': 'Todavía no has realizado ningún envío',
  'empty:no-incidents': 'No tienes ninguna incidencia en tus envíos',
  'empty:no-returns-title': 'No hay devoluciones para mostrar',
  'empty:no-returns-subtitle': 'Todavía no se ha realizado ninguna devolución',
  'empty:no-unscheduled-subtitle':
    'Todos tus envíos tienen una fecha de recogida programada.',
  'empty:try-another-search':
    'Puedes intentar otra búsqueda o volver al listado.',
  'empty:back-to-list': 'Volver al listado completo',
  'empty:everything-goes-smoothly': '¡Todo va sobre ruedas!',
  'empty:no-invoices': 'No hemos encontrado facturas con los filtros aplicados',

  // Session
  'session:about-to-expire': 'Tu sesión está a punto de expirar',
  'session:protect-data':
    'Para proteger tus datos, si no detectamos actividad en tu pantalla cerraremos la sesión en el tiempo indicado.',
  'session:if-session-closed': 'Si se cierra la sesión, ',
  'session:you-will-lose-data': 'perderás los datos de tu solicitud',
  'session:continue': 'Continuar con esta sesión abierta',
  'session:make-sure-completed-request':
    'Asegurate de que has completado la grabación de tu solicitud y/o terminado tu consulta antes de que se cierre la sesión',

  // Help
  'help:contact-support': 'Contacto y soporte',
  'help:solve-doubts': 'Este es el lugar en el que resolver todas tus dudas.',
  'help:attend-email': 'También te atendemos por correo electrónico',
  'help:solve-problems-remotely': 'Solucionamos tu problema en remoto',
  'help:team-viewer-info':
    'Te damos asistencia desde tu propio ordenador. Para ello debes tener instalada la licencia CTT de <link>Team Viewer</link>',
  'help:team-viewer-download': 'Descargar Team Viewer | Window',
  'help:team-viewer-download-mac': 'Descargar Team Viewer | Mac',
  'help:any-desk-download': 'Descargar AnyDesk | Window',
  'help:any-desk-download-mac': 'Descargar AnyDesk | Mac',
  'help:what-is-remote-control': '¿Qué es el control remoto?',
  'help:remote-control-info':
    'Mediante las aplicaciones de control remoto como Team Viewer podremos ayudarte a solucionar tus problemas de forma rápida y eficaz a la vez que garantizamos tu privacidad conforme a la <link>ley vigente</link>.',
  'help:minimum-system-requirements': 'Requisitos mínimos del sistema',
  'help:browsers':
    '<strong>Windows:</strong> Windows 7, Windows 8, Windows 8.1, Windows 10 Navegador Internet, Explorer 9 ó superior, Mozilla FireFox, Chrome, etc.<p><strong>Mac:</strong> MacOS 10.15, macOS 11.0, macOS 12.0, macOS 13.0, macOS 14.0.</p>',
  'help:user-manual': 'Manual y vídeos de usuario CTT',
  'help:user-manual-info':
    'Te ayudará a resolver cualquier duda acerca de la plataforma.',
  'help:write-your-message-here': 'Déjanos tu mensaje aquí',
  'help:user-manual-download': 'Descargar manual de usuario CTT',
  'help:customer-support': 'Atención al cliente',
  'help:informatic-support': 'Soporte informático',
  'help:commercial': 'Comercial',
  'help:billing': 'Facturación',
  'help:contact-form-info':
    'No utilizaremos ni tu correo ni tu teléfono para nada que no tenga que ver con esta consulta.',
  'help:send': 'Enviar',
  'help:download-user-manual': 'Descargar Manual de Usuario',
  'help:see-videos': 'Ver vídeos explicativos',
  'help:videos': 'Vídeos explicativos',
  'help:videos-text':
    'A través de los siguientes vídeos, en pocos minutos, puedes aprender cualquier funcionalidad de esta aplicación:',
  'help:success-form-sent':
    'Hemos recibido tu mensaje. En breve nos pondremos en contacto contigo.',
  'help:subject:placeholder': 'Motivo abreviado de la solicitud',
  'help:description:placeholder': 'Explica aquí el detalle de tu mensaje.',
  'help:shipmentNumber:placeholder': 'Introduce su numero de envío',

  // Business
  'shipping-state:WEB0000:name': 'MANIFESTADO',
  'shipping-state:WEB0000:description':
    'ENVÍO GRABADO: CTT EXPRESS A LA ESPERA DE RECEPCIONAR LA MERCANCÍA',
  'shipping-state:WEB0100:name': 'ORDEN DE RECOGIDA',
  'shipping-state:WEB0100:description':
    'RECOGIDA GRABADA: CTT EXPRESS A LA ESPERA DE RECOGER LA MERCANCÍA',
  'shipping-state:WEB0200:name': 'RECOGIDA PENDIENTE ACEPTACIÓN',
  'shipping-state:WEB0200:description': '',
  'shipping-state:WEB0300:name': 'RECOGIDA ASIGNADA',
  'shipping-state:WEB0300:description': 'RECOGIDA ASIGNADA A CONDUCTOR',
  'shipping-state:WEB0400:name': 'RECOGIDA ANULADA',
  'shipping-state:WEB0400:description': 'RECOGIDA ANULADA',
  'shipping-state:WEB0500:name': 'ENVIO RECOGIDO',
  'shipping-state:WEB0500:description': 'RECOGIDA EFECTUADA',
  'shipping-state:WEB0600:name': 'RECOGIDA FALLIDA',
  'shipping-state:WEB0600:description': 'RECOGIDA FALLIDA',
  'shipping-state:WEB0700:name': 'DELEGACIÓN ORÍGEN',
  'shipping-state:WEB0700:description': 'MERCANCÍA EN DELEGACIÓN DE ORIGEN',
  'shipping-state:WEB0800:name': 'EN CARGA',
  'shipping-state:WEB0800:description': '',
  'shipping-state:WEB0900:name': 'EN TRÁNSITO',
  'shipping-state:WEB0900:description': 'ENVÍO EN CURSO',
  'shipping-state:WEB1000:name': 'PLATAFORMA TRÁNSITO',
  'shipping-state:WEB1000:description': '',
  'shipping-state:WEB1100:name': 'MAL TRANSITADO "SOBRA"',
  'shipping-state:WEB1100:description': 'ENVÍO CON TRANSITO INCORRECTO',
  'shipping-state:WEB1200:name': 'DELEGACIÓN DESTINO',
  'shipping-state:WEB1200:description': 'MERCANCÍA EN DELEGACIÓN DESTINO',
  'shipping-state:WEB1300:name': 'REPARTO PRE-ASIGNADO',
  'shipping-state:WEB1300:description': '',
  'shipping-state:WEB1400:name': 'REPARTO ASIGNADO',
  'shipping-state:WEB1400:description': 'ENVÍO ASIGNADO A CONDUCTOR',
  'shipping-state:WEB1500:name': 'EN REPARTO',
  'shipping-state:WEB1500:description': 'ENVÍO EN REPARTO',
  'shipping-state:WEB1600:name': 'REPARTO FALLIDO',
  'shipping-state:WEB1600:description': 'REPARTO FALLIDO',
  'shipping-state:WEB1700:name': 'ESTACIONADO',
  'shipping-state:WEB1700:description':
    'ENVÍO ALMACENADO TEMPORALMENTE ("UBICACIÓN")',
  'shipping-state:WEB1800:name': 'ESTACIONADO UBICADO',
  'shipping-state:WEB1800:description': '',
  'shipping-state:WEB1900:name': 'PEDIENTE DE EXTRACCIÓN',
  'shipping-state:WEB1900:description': '',
  'shipping-state:WEB2000:name': 'ENTREGA COLABORADOR',
  'shipping-state:WEB2000:description': 'ENTREGADO A COLABORADOR DE REPARTO',
  'shipping-state:WEB2100:name': 'ENTREGA ENTREGADO',
  'shipping-state:WEB2100:description': '',
  'shipping-state:WEB2200:name': 'ENTREGA PARCIAL',
  'shipping-state:WEB2200:description': 'ENTREGADO PARCIALMENTE',
  'shipping-state:WEB2300:name': 'DEPOSITADO EN PUNTO CTT',
  'shipping-state:WEB2300:description': 'DISPONIBLE PARA RECOGER',
  'shipping-state:WEB2400:name': 'NUEVO REPARTO',
  'shipping-state:WEB2400:description': 'MERCANCÍA EN DELEGACIÓN DESTINO',
  'shipping-state:WEB2500:name': 'DEVOLUCIÓN',
  'shipping-state:WEB2500:description': 'ENVÍO DEVUELTO',
  'shipping-state:WEB2600:name': 'REEXPEDIDO/RECANALIZADO',
  'shipping-state:WEB2600:description': '',
  'shipping-state:WEB2700:name':
    'ALMACÉN REGULADOR ("NO REALIZADO", "DESTRUÍDO")',
  'shipping-state:WEB2700:description':
    'EXPEDIENTE INCIDENCIA CERRADA: Expediente cerrado de Incidencia gestionado con Origen. Contacte con el remitente para más información.',
  'shipping-state:WEB2800:name': 'NO LOCALIZADO',
  'shipping-state:WEB2800:description':
    'UBICACIÓN NO CONFIRMADA: Se ha producido una incidencia en el tránsito de su envío. Por favor, contacte con el remitente. Puede consultar el estado actualizado de su envío en www.cttexpress.com',
  'shipping-state:WEB2900:name': 'RECOGER EN DELEGACIÓN',
  'shipping-state:WEB2900:description': '',

  // Print settings
  'print-settings:title': 'Ajustes de impresión',
  'print-settings:label-printing-configuration':
    'Configuración de impresión de etiquetas',
  'print-settings:problems-installing-the-app':
    '¿Tienes problemas instalando la aplicación?',
  'print-settings:app-jspm-no-installed':
    'Al parecer no has instalado la aplicación de JSPM aún, o no esta actualizada. Recuerda reiniciar el navegador una vez hayas instalado el componente.',
  'print-settings:app-jspm-explanation':
    'Para simplificar el proceso de impresión de tus etiquetas y si tienes un volumen alto de solicitudes, te recomendamos instalar la applicación JSPrintManager la cual te facilitará a imprimir tus etiquetas.',
  'print-settings:install-jsprintmanager':
    'Instalar la applicación JSPrintManager',
  'print-settings:printer': 'Impresora',
  'print-settings:no-printer': 'No hay impresoras configuradas',
  'print-settings:reload-printers': 'Actualizar lista de impresoras',
  'print-settings:print-type': 'Tipo de impresión',
  'print-settings:print-model': 'Modelo de impresión',
  'print-settings:model-single': 'A6 (10,5 x 14,8cm)',
  'print-settings:model-single-description': '1 etiqueta por página',
  'print-settings:model-multi1': 'A4 (29,7 x 21cm)',
  'print-settings:model-multi1-description': '1 etiqueta por página',
  'print-settings:model-multi3': 'A4 (21 x 29,7cm)',
  'print-settings:model-multi3-description': '3 etiquetas por página',
  'print-settings:model-multi4': 'A4 (29,7 x 21cm)',
  'print-settings:model-multi4-description': '4 etiquetas por página',
  'print-settings:print-position:ask-always': 'Preguntar siempre',
  'print-settings:print-position:1': '1ª posición',
  'print-settings:print-position:2': '2ª posición',
  'print-settings:print-position:3': '3ª posición',
  'print-settings:print-position:4': '4ª posición',
  'print-settings:we-help-you': 'O ponte en contacto, nosotros te ayudamos.',
  'print-settings:support-link': 'soporte.web@cttexpress.com',
  'print-settings:download-print-manual':
    'Puedes descargar el manual de impresión ',
  'print-settings:link-text': 'aquí.',
  // Print alert
  'print-alert:title': '¡Imprime tus etiquetas más rápido!',
  'print-alert:description':
    '¿Normalmente imprimes muchas etiquetas? Si es así, descarga la aplicación e imprime tus etiquetas de una manera más rápida y fácil.',
  'print-alert:download-button': 'Descargar aplicación',
  'print-alert:i-want-know-more': 'Quiero saber más',
  'print-alert:app-not-installed':
    'Parece que aún no tienes la aplicación de impresión instalada. Descárgatela para poder imprimir tus etiquetas.',
  'print-alert:printer-not-configured':
    'Para poder imprimir tus etiquetas, necesitamos que antes configures tu impresora.',
  'print-alert:cancel-print-alert':
    'Recuerda que sólo se pueden descargar e imprimir etiquetas de aquellos envíos cuyo estado sea “Grabado”.',

  // Download Install JSPM App
  'download-install-jspm-app:title': 'Descarga e instala la App JSPM Client',
  'download-install-jspm-app:explanation':
    'Esta aplicación te ayudará a gestionar la impresión de tus etiquetas de una manera más rápida y fácil. Gracias a su función de impresión silenciosa, cada vez que hagas una solicitud de envío, tu etiqueta se podrá imprimir inmediatamente con sólo un click, evitando todos los pasos que requiere tu impresora normalmente.',
  'download-install-jspm-app:alert-license-title': 'Terminos y condiciones',
  'download-install-jspm-app:alert-license-content':
    'Haciendo click en “Descargar” estás aceptando el <link>Contrato de licencia del Software y las Póiticas de Privacidad de JSPM.</link>',
  'download-install-jspm-app:recommended-version': 'Versión recomendada',
  'download-install-jspm-app:helper-text-instructions':
    'Para configurar la impresión de las etiquetas es necesario tener el software JSPrintManager (JSPM). Recuerda leer detenidamente sus instrucciones antes de proceder con la instalación. Descarga el software de forma segura y gratuita aquí abajo.',
  'download-install-jspm-app:alert-recommended-version-not-obtained-content':
    'No se ha podido obtener una versión recomendada para tu ordenador, dirigite a la página de <link>JSPM Client</link> para encontrar la versión que mejor se adecue a tu dispositivo.',
  'download-install-jspm-app:url': 'fasd',
  'download-install-jspm-app:other-version':
    'Si necesitas descargar una versión distinta a la recomendada, dirigete a la página de <link>JSPM Client</link>.',
  'download-install-jspm-app:installation-instructions':
    'Instrucciones de instalación',
  'download-install-jspm-app:instructions-name':
    'Manual de instrucciones {operatingSystem}',
  'download-install-jspm-app:obtaining-installable': 'Obteniendo ejecutable',
  'download-install-jspm-app:obtaining-instructions':
    'Obteniendo instrucciones',

  // Print modal
  'choose-position-print-labels':
    'Elige la posición en la que deseas empezar a imprimir tus etiquetas',
  // TODO: @dev: dinamizar número y plural de palabra etiqueta según cantidad de etiquetas
  'your-are-going-to-print-number-labels':
    'Vas a imprimir un total de {shippingsCount, plural, one {1 etiqueta} other {{shippingsCount} etiquetas}}.',
  // TODO: @dev: dinamizar modelo y número de etiquetas
  'alert-print-modal:model-number-of-labels':
    'A4 (29,7 x 21 cm) - 4 etiquetas por página',
  'default-printing-model': 'Modelo de impresión predeterminado',
  'change-model-size-on-print-settings':
    'Puedes cambiar esta selección en los <link>Ajustes de impresión</link>',
  'print-modal:label-print-position': 'Posición de impresión',
  'print-modal:print-position-tooltip':
    'Elige desde que posición deseas que comience la impresión de tus etiquetas.',
  'print-modal:title': 'Impresión',
  'print-modal:body': 'Se ha enviado la etiqueta a la impresora ',
  'print-modal:first-position': '1º posición',
  'print-modal:second-position': '2º posición',
  'print-modal:third-position': '3º posición',
  'print-modal:fourth-position': '4º posición',

  // User zone
  'user-zone:welcome': `{name, select,
      unnamed {Bienvenido}
      other {Bienvenido, {name}}
    }`,
  'user-zone:explanation':
    'Aquí puedes consultar tus datos de contacto y actualizar tu contraseña.',
  'user-zone:contact-person': 'Persona de contacto',
  'user-zone:contact-data': 'Datos de contacto',
  'user-zone:client-code': 'Código de cliente',
  'user-zone:change-contact-data': 'Cambiar datos de contacto',
  'user-zone:contact-data-saved': 'Los datos de contacto han sido guardados.',
  'user-zone:contact-explanation':
    'Son los que utilizaremos para contactar contigo cuando sea necesario. Puedes cambiarlos cuando quieras. Procura mantenerlos actualizados',
  'user-zone:password': 'Contraseña',
  'user-zone:passwords-dont-match': 'Las contraseñas no coinciden.',
  'user-zone:password-must-have-a-number':
    'La contraseña debe tener al menos 1 número',
  'user-zone:password-must-have-an-uppercase-letter':
    'La contraseña debe tener al menos 1 mayúscula',
  'user-zone:confirm-password': 'Confirmar contraseña',
  'user-zone:password-msg-info':
    'Recuerda que tu contraseña tiene que tener, al menos, 8 caracteres, 1 mayúscula y 1 número.',
  'user-zone:change-password': 'Cambiar contraseña',
  'user-zone:bad-password': 'La contraseña actual no es correcta.',
  'user-zone:password-error':
    'Parece que tenemos un problema. Por favor, inténtalo de nuevo.',
  'user-zone:password-saved': 'La nueva contraseña ha sido guardada.',

  // Return
  'returns:activate:main-title':
    '¿Quieres solicitar la devolución de este envío?',
  'returns:activate:main-subtitle': 'Nº de envío: {shippingCode}',
  'returns:activate:main-info': 'Pasaremos a recoger tu mercancía por',
  'returns:activate:confirm-contact-data': 'Confirma los datos de contacto:',

  'returns:activate:activate-return':
    '¿Quieres activar la Recogida a la Carta?',
  'returns:activate:confirm-activate-return':
    'Sí, prefiero que mi cliente escoja dónde y cuando quiere entregar la mercancia',

  'return:activate:action:confirm': 'Sí, devolver mercancía',
  'return:activate:delivered-email-input': 'Email del remitente',
  'return:activate:delivered-email': 'Email del remitente para notificación:',
  'returns:success:main-title':
    'Tu devolución ha sido solicitada correctamente',
  'returns:success:alert':
    'Recuerda que en la sección Seguimiento de esta web puedes ver todos tus envíos y sus estados.',
  'returns:activate:remember-text':
    '*Recuerda que esta mercancía será devuelta a la dirección de origen y que conlleva coste. Más información en tu contrato o a través de tu consultor comercial.',
  'return:success:action:confirm': 'Volver a seguimiento',

  // Unscheduled pickup
  'unscheduled-pickup:main-title': 'Programar recogida',
  'unscheduled-pickup:main-subtitle':
    '¿Cuándo quieres que pasemos a recogerlo?',
  'unscheduled-pickup:option:asap': 'Lo más pronto posible',
  'unscheduled-pickup:option:chosse-day-and-hour': 'Quiero escoger día y hora',
  'unscheduled-pickup:asap-info':
    'Esta es la fecha en la que se recogerán tus paquetes en la dirección indicada.',
  'unscheduled-pickup:reminder':
    'Recuerda que cuando pasemos a recoger estos envíos podremos llevarnos todos los envíos que tengas preparados y etiquetados en ese momento.',
  'unscheduled-pickup:confirmation-title':
    'Tu recogida ha sido programada correctamente',
  'unscheduled-pickup:confirmation-subtitle':
    'En breve los cambios se visualizarán en la página de seguimiento',
  'unscheduled:success:action:confirm': 'Volver a seguimiento',
  'unscheduled-pickup:date:not-defined':
    'No definida. Te ofreceremos la fecha cuando programes la recogida o el envío sea recogido.',
  'action:schedule-pickup-option':
    'Programar {count, plural, one {recogida} other {recogidas}}',
  'unscheduled-pickup:table-header-title': 'Dirección de origen',
}

export default ES
